import React from 'react';
import BarSplitChart from './BarSplitChart';

const CurrencySplitChart = () => (
  <BarSplitChart
    title="Split Over Currency"
    endpoint="/dashboard/currency-split"
    cornerLabel="descending"
    barColor="var(--dash-chart-2)"
    maxRows={7}
  />
);

export default CurrencySplitChart;
